// extracted by mini-css-extract-plugin
module.exports = {"qsButton":"_2J9u_","qsButtonPrimary":"_3Ekb6","iconTextWrapper":"_3ETZw"};